import { isInMccmApp } from "../utils/isInMccmApp";

export const canUseAppBridge = () => {
  if (!isInMccmApp()) return false;

  return !!window;
};
